module.exports = __webpack_public_path__ + "static/media/retrollector_sidebar_2.88359bf5.png";